import { stepHandlers } from './steps';
import { agreementsHandlers } from './agreements';
import { facialBiometricsHandlers } from './facial-biometrics';
import { pixHandlers } from './pix';
import { tokenHandlers } from './token';
import { finishHandlers } from './finish';

export const requirmentHandlers = [
  ...stepHandlers,
  ...agreementsHandlers,
  ...facialBiometricsHandlers,
  ...pixHandlers,
  ...tokenHandlers,
  ...finishHandlers,
];
